import { useEffect, useState } from "react";
import Lenis from "lenis";
import axios from "axios";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Services from "@/components/Services";
import Salvage from "@/components/Salvage";
import PressCoverage from "@/components/PressCoverage";
import Projects from "@/components/Projects";
import Assets from "@/components/Assets";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ChatWidget from "@/components/ChatWidget";
import AdminPage from "@/pages/Admin";
import { LightboxProvider } from "@/lib/lightbox";
import { API } from "@/lib/store";
import { MANAGED_FLEET, MANAGED_PROJECTS } from "@/data/managedDefaults";

const LandingPage = ({ fleet, projects }) => {
  const fleetItems = fleet || MANAGED_FLEET;
  const projectItems = (projects || MANAGED_PROJECTS).map((p) => ({
    ...p,
    gallery: p.gallery || p.images || [],
  }));

  return (
    <LightboxProvider>
      <div className="bg-ink font-sans text-slate-100 antialiased">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Services />
          <Salvage />
          <PressCoverage />
          <Projects items={projectItems} />
          <Assets items={fleetItems} />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
        <ChatWidget />
      </div>
    </LightboxProvider>
  );
};

export default function App() {
  const [managed, setManaged] = useState({ fleet: null, projects: null });

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const load = async () => {
      const [f, p] = await Promise.all([
        axios.get(`${API}/content/fleet`).catch(() => null),
        axios.get(`${API}/content/projects`).catch(() => null),
      ]);
      setManaged({
        fleet: f?.data?.length ? f.data : null,
        projects: p?.data?.length ? p.data : null,
      });
    };
    load();
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <LandingPage fleet={managed.fleet} projects={managed.projects} />
            }
          />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </ErrorBoundary>
  );
}
